import axios from 'axios'
import store from '../store/store'

export default () => {
  const req = {
    baseURL: process.env.apiBaseURL // 'http://localhost:8081/api/'
  }
  if (store.state.token) req.headers = {
    Authorization: "Bearer " + store.state.token
  }
  // console.log("API baseUrl is " + req.baseURL) ;
  return axios.create(req) ;
  /*
  return axios.create({
    baseURL: 'http://localhost:8081/',
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
  */
}



// WEBPACK FOOTER //
// ./src/services/Api.js